import './StylesProvider.css'

import React, { ReactNode } from 'react'

import { StylesProvider as MaterialStylesProvider } from '@material-ui/styles'

export interface StylesProviderProps {
  children: ReactNode;
}

export const StylesProvider = ({ children }: StylesProviderProps): JSX.Element => {
  return (
    <MaterialStylesProvider injectFirst>
      {children}
    </MaterialStylesProvider>
  )
}
